import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Lead, LeadCreateDTO, LeadPage, LeadStatus,
  ConvertLeadDTO, LeadDisqualifyDTO, Opportunity,
} from '../interfaces/crm/crm.interface';

export const LeadService = {
  listByInstitution: async (
    institutionId: string,
    status?: LeadStatus,
    page = 0,
    size = 10,
  ): Promise<LeadPage> => {
    const statusParam = status ? `status=${status}&` : '';
    return (await axios.get(
      `${ENDPOINTS.CRM.LEAD.LIST_BY_INSTITUTION(institutionId)}?${statusParam}page=${page}&size=${size}`,
    )).data;
  },
  getById: async (id: string): Promise<Lead> =>
    (await axios.get(ENDPOINTS.CRM.LEAD.GET_BY_ID(id))).data,
  create: async (dto: LeadCreateDTO): Promise<Lead> =>
    (await axios.post(ENDPOINTS.CRM.LEAD.CREATE, dto)).data,
  update: async (id: string, dto: LeadCreateDTO): Promise<Lead> =>
    (await axios.put(ENDPOINTS.CRM.LEAD.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.CRM.LEAD.DELETE(id))).data,
  convert: async (id: string, dto: ConvertLeadDTO): Promise<Opportunity> =>
    (await axios.post(ENDPOINTS.CRM.LEAD.CONVERT(id), dto)).data,
  disqualify: async (id: string, dto: LeadDisqualifyDTO): Promise<Lead> =>
    (await axios.post(ENDPOINTS.CRM.LEAD.DISQUALIFY(id), dto)).data,
};
